
import React from 'react';
import { Button } from '@/components/ui/button';
import { NavigateFunction } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

export const renderScriptureNavigatorContent = (item: any, navigate: NavigateFunction) => {
  if (!item || !item.content) return <p>No content available</p>;

  // Handle single item content (verse, commentary, guidance)
  if (item.content.type) {
    return (
      <div className="space-y-6">
        <div>
          <h3 className="text-heaven-gold text-lg font-semibold">Topic:</h3>
          <p className="text-base">{item.content.topic || 'N/A'}</p>
        </div>

        <Card className="border-heaven-gold/10 shadow-sm">
          <CardHeader className="py-4">
            <CardTitle className="text-md flex justify-between items-center">
              <span>{item.content.reference || 'No reference'}</span>
            </CardTitle>
            <CardDescription className="mt-2 text-base whitespace-pre-wrap">
              {item.content.text || 'No text available'}
            </CardDescription>
            
            {item.content.context && (
              <div className="mt-3 text-sm">
                <p className="font-medium text-heaven-gold">Explanation:</p>
                <p className="text-muted-foreground">{item.content.context}</p>
              </div>
            )}

            {item.content.commentary && (
              <div className="mt-4 text-sm">
                <p className="font-medium text-heaven-gold">Commentary:</p>
                <p className="text-muted-foreground whitespace-pre-wrap">{item.content.commentary}</p>
              </div>
            )}

            {item.content.guidance && (
              <div className="mt-4 text-sm">
                <p className="font-medium text-heaven-gold">Guidance:</p>
                <p className="text-muted-foreground whitespace-pre-wrap">{item.content.guidance}</p>
              </div>
            )}
          </CardHeader>
        </Card>
      </div>
    );
  }

  // Handle multiple scriptures content
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-heaven-gold text-lg font-semibold">Topic:</h3>
        <p className="text-base">{item.content.topic || 'N/A'}</p>
      </div>

      {item.content.scriptures && Array.isArray(item.content.scriptures) && (
        <div className="space-y-6">
          <h3 className="text-heaven-gold text-lg font-semibold">Scriptures:</h3>
          {item.content.scriptures.map((scripture: any, i: number) => (
            <Card key={i} className="border-heaven-gold/10 shadow-sm">
              <CardHeader className="py-4">
                <CardTitle className="text-md flex justify-between items-center">
                  <span>{scripture.reference || `Scripture ${i+1}`}</span>
                </CardTitle>
                <CardDescription className="mt-2 text-base whitespace-pre-wrap">
                  {scripture.text || 'No text available'}
                </CardDescription>
                
                {scripture.context && (
                  <div className="mt-3 text-sm">
                    <p className="font-medium text-heaven-gold">Explanation:</p>
                    <p className="text-muted-foreground">{scripture.context}</p>
                  </div>
                )}

                {scripture.commentary && (
                  <div className="mt-4 text-sm">
                    <p className="font-medium text-heaven-gold">Commentary:</p>
                    <p className="text-muted-foreground whitespace-pre-wrap">{scripture.commentary}</p>
                  </div>
                )}
              </CardHeader>
            </Card>
          ))}
        </div>
      )}
      <Button
        onClick={() => navigate(`/scripture-navigator`)}
        className="mt-6"
      >
        Go to Scripture Navigator Tool
      </Button>
    </div>
  );
};

